import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Tir } from '../bo/tir';
import { GraphData, GraphDataDto } from '../bo/blastModel/fragmentation';

type MuckpileDto = Record<string, unknown>;

 const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  
@Injectable({
  providedIn: 'root'
})
export class BlastService {

  constructor(private readonly http: HttpClient) { }
  
  
  public getBlast(blastId: number):Observable<Tir> {
    return this.http.get<Tir>(environment.exploreURL + '/blasts/' + blastId , httpOptions);
  }

  public async getFragmentationData(blastId:number):Promise<GraphData> {
    const rawData= await this.http.get<GraphDataDto>(environment.exploreURL + '/blasts/' + blastId + '/fragmentation', httpOptions).toPromise();

    if (!rawData) {
      return new GraphData();
    }

    return this.ExtractFragValues(rawData.cumul_graph, 50);
    
  }
  public getMuckpileImage(blastId: number): Observable<Blob> {
    return this.http.get(environment.exploreURL + '/blasts/' + blastId + '/fragmentation/images', { responseType: 'blob' });
  }

  public getMuckpileList(blastId: number): Observable<MuckpileDto[]> {
    return this.http.get<MuckpileDto[]>(environment.exploreURL + '/blasts/' + blastId + '/fragmentation/images/list');
  }

  public getMuckpileImageById(blastId: number, muckpileId: number): Observable<Blob> {
    return this.http.get(environment.exploreURL + '/blasts/' + blastId + '/fragmentation/images/' + muckpileId, { responseType: 'blob' });
  }

  public deleteMuckpile(blastId: number, muckpileId: number): Observable<void> {
    return this.http.delete<void>(environment.exploreURL + '/blasts/' + blastId + '/fragmentation/images/' + muckpileId);
  }

  private ExtractFragValues(data: number[][], threshold: number): GraphData {
    if (data.length === 0) return new GraphData();

    let filteredData = [data[0]];
    let histogram = []
    let lastGate = 0;

    let lastValue = filteredData[filteredData.length - 1];

    for (let i = 1; i < data.length; i++) {
      if (Math.abs(data[i][0] - lastValue[0]) >= threshold) {
        const gate = data[i][1];
        filteredData.push(data[i]);
        
        histogram.push(gate - lastGate);
        lastGate = gate;
      }
    }
    //push last value
    filteredData.push(data[data.length-1]);

    let res = new GraphData()
    res.sizes = filteredData.map(entry => entry[0]);
    res.cumulPercent = filteredData.map(entry => entry[1]);
    res.percent = histogram;
    res.rawCumulGraph = data;

    return res;
  }

   public markAsBlasted(tirId: number, effectiveDate: Date, isBlasted: boolean): Observable<Tir> {
    const params = new HttpParams()
      .set('effectiveDate', effectiveDate.toISOString())
      .set('isBlasted', isBlasted.toString());
    return this.http.put<Tir>(`${environment.exploreURL}/blasts/${tirId}/MarkAsBlasted`, null, {
        ...httpOptions,
        params: params
    });
}
  
}

